import React from 'react';
import './WhyUs.css';

const WhyUs = () => {
  return (
    <div className="why-us">
      <div className="container">
        <div className="why-us-header">
          <h1>Why Choose <span className="brand-name"><span className="brand-let">Let</span><span className="brand-apostrophe">'</span><span className="brand-s">s</span><span className="brand-pay">pay</span></span>?</h1>
          <div className="info-block">
            <p className="why-us-subtitle">
              Experience the difference with our proven track record and innovative solutions
            </p>
          </div>
        </div>

        <div className="why-us-content">
          <div className="experience-section">
            <h2>Experience</h2>
            <div className="experience-grid">
              <div className="experience-item">
                <div className="experience-number">1000+</div>
                <div className="experience-text">Man-years of experience across payment and enterprise domains</div>
              </div>
              <div className="experience-item">
                <div className="experience-number">16+</div>
                <div className="experience-text">Years of working closely with clients in different countries</div>
              </div>
              <div className="experience-item">
                <div className="experience-number">Global</div>
                <div className="experience-text">Presence across all continents with international recognition</div>
              </div>
            </div>
          </div>

          <div className="professional-expertise">
            <h2>Professional Expertise</h2>
            <div className="expertise-grid">
              <div className="expertise-card">
                <h3>Risk Management</h3>
                <p>Worked in multiple risk regions and verticals, providing secure solutions in challenging environments.</p>
              </div>
              <div className="expertise-card">
                <h3>Industry Knowledge</h3>
                <p>A pool of human minds with deep-rooted knowledge across multiple industry verticals.</p>
              </div>
              <div className="expertise-card">
                <h3>Payment Associations</h3>
                <p>Consultation on handling payment associations like VISA and Mastercard operations.</p>
              </div>
            </div>
          </div>

          <div className="approach-section">
            <h2>Hands-on Approach</h2>
            <div className="approach-features">
              <div className="approach-feature">
                <div className="feature-icon">🤝</div>
                <h3>End-to-End Partnership</h3>
                <p>Work with you from inception to closure, ensuring all objectives are fulfilled.</p>
              </div>
              <div className="approach-feature">
                <div className="feature-icon">🎯</div>
                <h3>Focused Delivery</h3>
                <p>Stay till the end to ensure you get the objectives fulfilled with complete satisfaction.</p>
              </div>
              <div className="approach-feature">
                <div className="feature-icon">🏢</div>
                <h3>SME Empowerment</h3>
                <p>We work with SMEs as a separate focus area to empower them with automation while managing risk.</p>
              </div>
            </div>
          </div>

          <div className="infrastructure-section">
            <h2>Infrastructure & Facilities</h2>
            <div className="infrastructure-grid">
              <div className="infrastructure-item">
                <h3>Self-Owned Facilities</h3>
                <p>Our own office, storage, and working facilities ensure complete control and security.</p>
              </div>
              <div className="infrastructure-item">
                <h3>Global Network</h3>
                <p>Established presence across all continents with local support and expertise.</p>
              </div>
              <div className="infrastructure-item">
                <h3>24/7 Support</h3>
                <p>Round-the-clock customer support through our automated workflow-based helpdesk.</p>
              </div>
            </div>
          </div>

          <div className="quality-section">
            <h2>Quality Standards</h2>
            <div className="quality-features">
              <div className="quality-feature">
                <span className="quality-icon">✓</span>
                <span>Second to none quality standards</span>
              </div>
              <div className="quality-feature">
                <span className="quality-icon">✓</span>
                <span>Customer-centric service approach</span>
              </div>
              <div className="quality-feature">
                <span className="quality-icon">✓</span>
                <span>State-of-the-art IT solutions</span>
              </div>
              <div className="quality-feature">
                <span className="quality-icon">✓</span>
                <span>Highly motivated professional team</span>
              </div>
              <div className="quality-feature">
                <span className="quality-icon">✓</span>
                <span>Comprehensive testing and validation</span>
              </div>
              <div className="quality-feature">
                <span className="quality-icon">✓</span>
                <span>Continuous improvement and innovation</span>
              </div>
            </div>
          </div>

          <div className="technology-section">
            <h2>Advanced Technology Features</h2>
            <div className="tech-features-grid">
              <div className="tech-feature-card">
                <div className="tech-icon">🔍</div>
                <h3>Real Audit Trail</h3>
                <p>Complete transaction tracking with secure audit trails for every payment processed.</p>
              </div>
              <div className="tech-feature-card">
                <div className="tech-icon">📊</div>
                <h3>Real-Time Reports</h3>
                <p>Actionable reports generated in real-time with comprehensive analytics and insights.</p>
              </div>
              <div className="tech-feature-card">
                <div className="tech-icon">🌐</div>
                <h3>Remote Payment</h3>
                <p>Process payments remotely with secure, encrypted transactions from any location.</p>
              </div>
              <div className="tech-feature-card">
                <div className="tech-icon">📍</div>
                <h3>GPS Tagged Payments</h3>
                <p>Location-based payment tracking with GPS coordinates for enhanced security and monitoring.</p>
              </div>
              <div className="tech-feature-card">
                <div className="tech-icon">💳</div>
                <h3>Multiple Payment Methods</h3>
                <p>Support for Cash, Debit, Credit Cards, Mobile Wallets, and direct bank deposits.</p>
              </div>
              <div className="tech-feature-card">
                <div className="tech-icon">🤖</div>
                <h3>Business Intelligence & AI</h3>
                <p>Advanced AI-powered analytics and business intelligence for predictive insights.</p>
              </div>
            </div>
          </div>

          <div className="revenue-section">
            <h2>Revenue Collection Excellence</h2>
            <div className="revenue-content">
              <div className="revenue-text">
                <p>
                  An increase in revenue collection can be achieved through employing county revenue instruments 
                  for tax collection, as well as exploiting and harnessing all available sources of revenue in 
                  their localities, and devising a cost-effective means of collecting revenues.
                </p>
                <div className="revenue-features">
                  <div className="revenue-feature">
                    <span className="feature-icon">📄</span>
                    <span>Printed, emailed, or e-receipt for every transaction</span>
                  </div>
                  <div className="revenue-feature">
                    <span className="feature-icon">🖥️</span>
                    <span>All reports on single window dashboard</span>
                  </div>
                  <div className="revenue-feature">
                    <span className="feature-icon">💰</span>
                    <span>Cost-effective solutions</span>
                  </div>
                  <div className="revenue-feature">
                    <span className="feature-icon">⚡</span>
                    <span>Real-time processing with automatic reconciliation</span>
                  </div>
                </div>
              </div>
              <div className="revenue-image">
                <img 
                  src="/images/Realtime Payment Solution.png" 
                  alt="Let'spay Revenue Collection Solutions" 
                  className="section-image"
                />
              </div>
            </div>
          </div>

          <div className="security-section">
            <h2>Security & Trust</h2>
            <div className="security-content">
              <div className="security-image">
                <img 
                  src="/images/Network architecture.png" 
                  alt="Let'spay Security Architecture" 
                  className="section-image"
                />
              </div>
              <div className="security-text">
                <p>
                  Whenever a new tech solution makes its debut, someone tries to hack it. Despite the growing 
                  popularity of mobile banking, security breaches continue to pose a significant threat. 
                  Players will need to ensure their mobile platforms can provide a high level of data security.
                </p>
                <div className="security-features">
                  <div className="security-feature">
                    <h4>Bank-Grade Security</h4>
                    <p>Tier one banking core system with enterprise-level security protocols</p>
                  </div>
                  <div className="security-feature">
                    <h4>AI-Powered Protection</h4>
                    <p>Artificial intelligence used in finance to predict suspect activities and make risk assessments</p>
                  </div>
                  <div className="security-feature">
                    <h4>Human Expertise</h4>
                    <p>No substitute for human discretion and expertise when it comes to complex financial services</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyUs;
